import React from "react"
import { Box } from "@chakra-ui/react"
import {
  BadgeElement,
  BadgeElementType,
  BadgeLineData,
} from "sharedTypes/badge"
import { EDITOR_RESOLUTION } from "../utils/constants"

type Props = {
  element: BadgeElement
  scaleFactor?: number
}

const BadgeLine = ({ element, scaleFactor = EDITOR_RESOLUTION }: Props) => {
  if (element.type !== BadgeElementType.LINE) return null

  const data = element.data as BadgeLineData

  // Convert thickness from mm to editor pixels using scale factor (mm to px conversion)
  const scaledThickness = data.thickness * scaleFactor

  return (
    <Box
      w="full"
      h="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        w="full"
        h="0"
        borderBottomWidth={`${scaledThickness}px`}
        borderBottomStyle={data.style}
        borderBottomColor={data.color}
      />
    </Box>
  )
}

export default BadgeLine
